var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCopied = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#568DFE",
  fillRule: "evenodd",
  d: "M10.88 6a4.88 4.88 0 1 1-9.76 0 4.88 4.88 0 0 1 9.76 0M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0M9.097 3.186 4.836 7.447 2.903 5.515l-.791.791L4.44 8.635l.396.395.396-.395 4.656-4.657z",
  clipRule: "evenodd"
})));
export default SvgIconCopied;